import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff, ListChecks } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errMsg, LEVELS, SUBJECTS } from "@/lib/api";

// Admin: show or hide the students' quiz button, separately for each language and level.
export const QuizVisibility = () => {
  const [map, setMap] = useState(null);

  useEffect(() => {
    api.get("/admin/quiz-visibility")
      .then((r) => setMap(Object.fromEntries((Array.isArray(r.data) ? r.data : []).map((x) => [`${x.subject}-${x.level}`, x.visible]))))
      .catch(() => setMap({}));
  }, []);

  const toggle = async (subject, level, visible) => {
    const key = `${subject}-${level}`;
    setMap((m) => ({ ...m, [key]: visible }));
    try {
      await api.put("/admin/quiz-visibility", { subject, level, visible });
      toast.success(`${visible ? "ظهر" : "اختفى"} زر الاختبار: ${SUBJECTS.find((s) => s.id === subject)?.ar} · ${LEVELS.find((l) => l.n === level)?.name}`);
    } catch (e) {
      setMap((m) => ({ ...m, [key]: !visible }));
      toast.error(errMsg(e));
    }
  };

  if (!map) return null;
  return (
    <section className="bg-white border border-[#E5DCCB] p-5 mb-8" data-testid="admin-quiz-visibility">
      <h2 className="font-display text-xl font-bold inline-flex items-center gap-2"><ListChecks className="w-5 h-5 text-[#047857]" /> ظهور زر الاختبار للطلاب</h2>
      <p className="text-sm text-stone-600 mt-1 mb-4">شغّل أو أوقف زر «اختبار الفهم» لكل لغة ومستوى. عند الإيقاف لا يرى الطلاب الاختبار، وتبقى الأسئلة والنتائج محفوظة.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {SUBJECTS.map((s) => (
          <div key={s.id} className="border border-[#E5DCCB] rounded-sm p-3" data-testid={`admin-quiz-visibility-${s.id}`}>
            <p className="font-bold mb-2" style={{ color: s.tone }}>{s.ar}</p>
            <ul className="space-y-2">
              {LEVELS.map((l) => {
                const on = map[`${s.id}-${l.n}`] !== false;
                return (
                  <li key={l.n} className="flex items-center justify-between gap-2 text-sm">
                    <span className="inline-flex items-center gap-1.5">
                      {on ? <Eye className="w-4 h-4 text-[#047857]" /> : <EyeOff className="w-4 h-4 text-stone-500" />}
                      المستوى {l.n} · {l.name}
                    </span>
                    <Switch dir="ltr" checked={on} onCheckedChange={(v) => toggle(s.id, l.n, v)} aria-label={`زر الاختبار ${s.ar} المستوى ${l.n}`}
                      data-testid={`admin-quiz-visibility-switch-${s.id}-${l.n}`} className="data-[state=checked]:bg-[#047857]" />
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};
